// export const BASE_URL = `http://192.168.0.167/phoenix/public/api`;

// Stagging URL

// export const BASE_URL = `https://appdevprojects.co/phoenix/public/api`;
export const ADMIN_URL = `https://appdevprojects.co/phoenix/public/admin/login`;
export const ADMIN_URL_LIVE = `https://phoeniximmobilizer.com/admin`;

// Live URL

// Live URL

export const BASE_URL = `https://phoeniximmobilizer.com/api`;

export const app_id = "2027150";
export const key = "d521826362b18bbace82";
export const secret = "4bd90e68a6a76aa20ab2";
export const cluster = "mt1";

export const Map_Api_Key = "AIzaSyAHg0dE0Z24cySlSDYypDt-WZJPXOImvGI";

const Apis = {
  //Auth
  login: `${BASE_URL}/signIn`,
  signUp: `${BASE_URL}/signUp`,
  verifySignUpOtp: `${BASE_URL}/verifySignUpOtp`,
  sendVerificationOtp: `${BASE_URL}/sendVerificationOtp`,
  verifyForgotPasswordCode: `${BASE_URL}/verifyForgotPasswordCode`,
  resetPassword: `${BASE_URL}/resetPassword`,
  changePassword: `${BASE_URL}/changePassword`,
  logout: `${BASE_URL}/logout`,
  verifyOtp: `${BASE_URL}/verifyOtp`,
  delete_user: `${BASE_URL}/deleteUser`,

  // pages
  pages: (type) => `${BASE_URL}/pages?type=${type}`,

  //Change password
  changePassword: `${BASE_URL}/changePassword`,
  contactUs: `${BASE_URL}/contactUs`,
  emailNotification: `${BASE_URL}/updateSettings`,

  // **********************************************DealerShip**********************************************

  dealershipDashboard: `${BASE_URL}/dealership/getDashboard`,
  getUserData: `${BASE_URL}/dealership/getUserData`,
  updateProfile: `${BASE_URL}/dealership/updateProfile`,
  accountSetup: `${BASE_URL}/dealership/accountSetup`,
  updateCompanyProfile: `${BASE_URL}/dealership/updateCompanyProfile`,
  createAsset: `${BASE_URL}/dealership/createAsset`,
  singleAssets: `${BASE_URL}/dealership/singleAssets`,
  singleAssetsDetails: (id) => `${BASE_URL}/dealership/assetDetail/${id}`,
  downlink: `${BASE_URL}/dealership/assetDownLinkAction`,
  pendingAssets: `${BASE_URL}/dealership/pendingAssets`,
  deletePendingAssets: `${BASE_URL}/dealership/deletePendingAssets`,
  unlinkAssets: `${BASE_URL}/dealership/unlinkedAssets`,
  uploadAssets: `${BASE_URL}/dealership/importAssets`,
  exportAssets: `${BASE_URL}/dealership/exportAssets`,
  getSharedAccess: `${BASE_URL}/dealership/sharedAndSoldAssets`,
  importVautoAssets: `${BASE_URL}/dealership/importVautoAssets`,
  getVautoAssets: (type, name) =>
    `${BASE_URL}/dealership/vautoAssets?${type ? "type=" + type : ""}${name ? "&name=" + name : ""}`,

  // Activity logs
  activityLogs: `${BASE_URL}/dealership/activityLogs`,

  // getBatteryVolt: `${BASE_URL}/customer/updateBatteryVolt`,

  //modules
  getModules: (url) => (url ? url : `${BASE_URL}/dealership/unassignModules`),
  getAssignDevices: (url) =>
    url ? url : `${BASE_URL}/dealership/assignedModules`,
  getHistoryDevices: (url) =>
    url ? url : `${BASE_URL}/dealership/deviceHistory`,
  getUnlinkModules: `${BASE_URL}/dealership/getUnlinkModules`,
  createModules: `${BASE_URL}/dealership/createModules`,
  updateAssets: `${BASE_URL}/dealership/updateAsset`,
  deleteAssets: `${BASE_URL}/dealership/deleteAsset`,
  updateAssetLot: `${BASE_URL}/dealership/updateAssetLot`,
  deleteModuleFromAsset: (id) =>
    `${BASE_URL}/dealership/unlinkAssetFromModule/${id}`,
  moduleDetails: (id) => `${BASE_URL}/dealership/moduleDetail/${id}`,
  assignAsset: `${BASE_URL}/dealership/assignAsset`,
  exportDevices: `${BASE_URL}/dealership/exportDevices`,

  //Module Status
  dealerShipStatus: `${BASE_URL}/dealership/updateDealershipStatus`,
  carStatus: `${BASE_URL}/dealership/updateCarStatus`,

  //Schedule
  createUpdateSchedule: `${BASE_URL}/dealership/updateAssetSchedule`,
  deleteSchedule: `${BASE_URL}/dealership/deleteAssetSchedule`,
  scheduleStatus: (id) =>
    `${BASE_URL}/dealership/updateAssetScheduleStatus/${id}`,

  //Group Asset
  createAssetGroup: `${BASE_URL}/dealership/createAssetGroup`,
  updateAssetGroup: `${BASE_URL}/dealership/updateAssetGroup`,
  deleteAssetGroup: `${BASE_URL}/dealership/deleteAssetGroup`,
  getAssetGroup: `${BASE_URL}/dealership/groupAssets`,
  assetsGroupDetails: (id) => `${BASE_URL}/dealership/assetGroupDetail/${id}`,
  getassestsbygroup_id: `${BASE_URL}/dealership/getGroupVehicles`,
  vehicleDetailByID: (id) => `${BASE_URL}/dealership/assetDetail/${id}`,

  //Group Schedule
  createUpdateGroupSchedule: `${BASE_URL}/dealership/updateAssetGroupSchedule`,
  deleteGroupSchedule: `${BASE_URL}/dealership/deleteAssetGroupSchedule`,
  scheduleGroupStatus: (id) =>
    `${BASE_URL}/dealership/updateAssetGroupScheduleStatus/${id}`,
  groupDownlink: `${BASE_URL}/dealership/groupAssetsDownLinkAction`,
  groupAssetDownlink: `${BASE_URL}/dealership/groupAssetDownLinkAction`,

  //Staff
  getStaff: `${BASE_URL}/dealership/staff`,
  createStaff: `${BASE_URL}/dealership/staff/create`,
  updateStaff: `${BASE_URL}/dealership/staff/update`,
  deleteStaff: `${BASE_URL}/dealership/staff/delete`,
  //Chat
  getMessages: (url) => (url ? url : `${BASE_URL}/chats`),
  send_message: `${BASE_URL}/sendMessage`,

  //Access Sharing
  dealer_shareAccess: `${BASE_URL}/dealership/sharingAccess`,
  dealer_removeAccess: `${BASE_URL}/dealership/removeSharingAccess`,
  dltModule: `${BASE_URL}/dealership/deleteModule`,

  // getBatteryVolt: `${BASE_URL}/dealership/updateBatteryVolt`,
  //Notifications

  //License Management
  getAllLicense: `${BASE_URL}/dealership/licenseAgreements`,
  extendLicense: `${BASE_URL}/dealership/extendLicense`,

  //Sales history
  salesHistory: `${BASE_URL}/dealership/salesHistory`,

  // Lockdown
  lockdown: (end_route) => `${BASE_URL}/dealership/lot${end_route}`,

  notifications: (url) => (url ? url : `${BASE_URL}/notifications`),

  /////////////////////////////////////////////////Customer////////////////////////////////////////////////////
  cus_dashboard: `${BASE_URL}/customer/getDashboard`,

  //MODULES
  cus_modules: `${BASE_URL}/customer/modules`,
  cus_moduleDetails: (id) => `${BASE_URL}/customer/moduleDetail/${id}`,
  cus_shareAccess: `${BASE_URL}/customer/sharingAccess`,
  cus_createModules: `${BASE_URL}/customer/createModules`,

  //ASSETS
  cus_Assets: `${BASE_URL}/customer/getAllAssets`,
  cus_createAssets: `${BASE_URL}/customer/createAsset`,
  cus_assetDetail: (id) => `${BASE_URL}/customer/assetDetail/${id}`,
  cus_updateAssets: `${BASE_URL}/customer/updateAsset`,
  cus_deleteAssets: `${BASE_URL}/customer/deleteAsset`,
  cus_downlink: `${BASE_URL}/customer/assetDownLinkAction`,
  cus_unlinkAssets: (id) => `${BASE_URL}/customer/unlinkAssetFromModule/${id}`,
  cus_assignAsset: `${BASE_URL}/customer/assignAsset`,
  cus_getUnlinkAssets: `${BASE_URL}/customer/unlinkedAssets`,

  //Schedule
  cus_createUpdateSchedule: `${BASE_URL}/customer/updateAssetSchedule`,
  cus_deleteAssetSchedule: `${BASE_URL}/customer/deleteAssetSchedule`,
  cus_updateStatusSchedule: (id) =>
    `${BASE_URL}/customer/updateAssetScheduleStatus/${id}`,

  getBatteryVolt: `${BASE_URL}/customer/updateBatteryVolt`,

  cus_downlink: `${BASE_URL}/customer/assetDownLinkAction`,

  removeAccess: `${BASE_URL}/customer/removeSharingAccess`,

  // cus_deleteAssetSchedule: `${BASE_URL}/customer/deleteAssetSchedule`,
  // scheduleStatus: (id) =>
  //   `${BASE_URL}/dealership/updateAssetScheduleStatus/${id}`,
  company: (api, url) => (url ? url : `${BASE_URL}/company/${api}`),
  salesHistory: `${BASE_URL}/dealership/salesHistory`,
  revertSoldModule: `${BASE_URL}/dealership/revertSoldModule`,
  importUnprotectedAssets: `${BASE_URL}/dealership/importUnprotectedAssets`,
};
export default Apis;
